import {
    AppSettingsMode,
    DEFAULT_TEMPLATE_ID,
    LOCAL_INHERITED_TEMPLATE_ID
} from '../../manager/app-settings/app-settings'
import ViewTemplates from "../../../core/manager/view-templates/view-templates"
import {ViewType} from "../../gd/const/views/view-type"
import {BUS_SETTINGS_MANAGER_CONFIG_CHANGED} from "../../gd/bus/bus-event-type"
import {TasksViewAppSettings} from "../tasks-view/core/@types"

// eto hernya - why here ??? huh ... kazdii module svoi imeet... bred
export enum SettingsVersion {
    VERSION_1 = 1,
    VERSION_2 = 2,
    VERSION_3 = 3,
}

// const debug = "ModuleSettings"
const debug = false

export default class ModuleSettings {

    protected _templateId?              : string   // view settings preset template name

    // need better proto class with appSettings but too much work for now so we just @ts---ignore appSettingsd usage in here
    public localSettings                : any // LocalSettingsProto // local settings we use with current view


    public _mode                        : AppSettingsMode = AppSettingsMode.CUSTOM
    public _isLocal                     : boolean   = false // not saved to project settings

    protected _inheritedFromProject     : any

    public defaultAppSettings           : TasksViewAppSettings
    public _initialConfig               : TasksViewAppSettings

    protected inheritAppSettings        : boolean = false   // ?
    protected templateIgnoredParams     : string[] = []     // params that are not in view template and stored separately

    constructor(appSettingsConfig:TasksViewAppSettings, localSettings:any, defaultAppSettings:TasksViewAppSettings) {

        // appSettingsConfig - config with settings we store in DB
        // localSettings - initialized local settings instance
        // defaultAppSettings - default settings values

        this.localSettings      = localSettings;
        this.defaultAppSettings = defaultAppSettings;

        // save initial config for changes comparison in isConfigChanged() and to restore values on reset()
        // should be set to some default config in child class if appSettingsConfig is undefined
        // this._initialConfig = appSettingsConfig;


        // reinit (code duplicate from super class) is required because of Typescript _templateId flush

        // this code removed and should be execvuted at child level
        // // check if we have local app settings overridden
        // let config;
        // if (this.localSettings.appSettings) config = this.localSettings.appSettings
        // else                                config = appSettingsConfig
        //
        // // initialize our settings
        // this._init(config)

        this._initialConfig = this.normalizeConfig(appSettingsConfig || {})

        // mode for current settings ?
        this._isLocal   = false; // not saved to project settings
        this.updateMode();
    }


    loadFromJSON(appSettingsConfig:any) {
        this._init(appSettingsConfig);
    }

    // reset all parameters to initial values (delete local settings)
    reset(appSettingsConfig?:any) {
        if (appSettingsConfig) this._initialConfig = this.normalizeConfig(appSettingsConfig); // reset to this config if passed


        // @ts-ignore
        this.localSettings.appSettings = null;
        this.localSettings.save();
        this._init(this._initialConfig);
        gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)
    }

    configToJSON() {
        return this.normalizeConfig(this);
    }

    confirmChanges() {
        this._initialConfig = this.configToJSON()
    }

    configToSave() {
        if (this._inheritedFromProject) {
            return {}
        }

        return this.configToJSON()
    }

    getInheritedAppSettings(): any {
        /*should be overridden if this.inheritAppSettings is true*/
        return null
    }

    _init(appSettingsConfig:any) {

        // if localSettings.appSettings.templateId is LOCAL_INHERITED_TEMPLATE_ID and inheritAppSettings is true
        // then we need to load inherited appSettings ignoring passed appSettingsConfig
        // (found no other way to implement local inherited settings)

        let appSettings
        const templateId = _.get(this.localSettings, 'appSettings.templateId', null)
        if (templateId === LOCAL_INHERITED_TEMPLATE_ID && this.inheritAppSettings) {
            appSettings = this.getInheritedAppSettings()
        } else {
            appSettings = appSettingsConfig
        }

        this._inheritedFromProject =   gd.session.projects.get(_.get(appSettings, 'inheritedFromProjectId',   null)) || null

        this._templateId =      appSettings ? appSettings.templateId : DEFAULT_TEMPLATE_ID;

        if (this._templateId)   {
            // get settings that are not stored in template
            const appSettingsNotInTemplate = _.pick(appSettings, this.templateIgnoredParams)
            this._initFromTemplate(appSettingsNotInTemplate)
        } else {
            this._initSettings(appSettings);
        }

        this.updateMode();
    }

    _initSettings(appSettingsConfig:any) {
        /*should be overridden*/
    }

    updateMode() {
        if (!!this._inheritedFromProject || _.get(this.localSettings, 'appSettings.templateId', null) === LOCAL_INHERITED_TEMPLATE_ID) {
            this._mode = AppSettingsMode.INHERITED
        } else if (!!this._templateId) {
            this._mode = AppSettingsMode.TEMPLATE
        } else {
            this._mode = AppSettingsMode.CUSTOM;
        }

        this._isLocal = this.isConfigChanged();
    }

    get autoSave() {
        return false
    }

    get mode() {return this._mode}
    get isLocal() {return this._isLocal}

    get systemType():ViewType {
        /*should be overridden*/
        return ViewType.PROJECT_LIST; // example
    }

    _initFromTemplate(appSettingsConfig?:any) {
        if (this._templateId) {
            // get template settings
            const templateAppSettings = new ViewTemplates().getTemplate(this.systemType, this._templateId)!.appSettings
            // combine template settings and settings not from template
            const appSettings = _.assign({}, templateAppSettings, appSettingsConfig)
            // init settings from combined config
            this._initSettings(appSettings)
        }
    }

    changeParameters(params: {[paramName:string]:any}) {
        debug && console.log(debug, "changeParameters", params)

        let isChanged = false
        _.mapKeys(params, (value,paramName)=>{
            const _paramName = '_{0}'.f(paramName);

            // @ts-ignore
            if (!_.isEqual(this[_paramName], value)) {
                this._inheritedFromProject = null
                this._templateId = undefined

                // @ts-ignore
                this[_paramName] = value
                isChanged = true
            }
        })

        if (isChanged) {
            this._onConfigChanged()
        }

        this.updateMode();
    }

    _onChangeParameter(paramName:string, value:any) {
        const _paramName = '_{0}'.f(paramName);

        debug && console.log(debug, "_onChangeParameter", paramName, !_.isEqual(this[_paramName as keyof {}], value), _.cloneDeep(this[_paramName as keyof {}]), _.cloneDeep(value))

        if (!_.isEqual(this[_paramName as keyof {}], value)) {
            this._inheritedFromProject = null;
            this._templateId = undefined

            // @ts-ignore
            this[_paramName] = value;
            this._onConfigChanged();
        }

        this.updateMode();
    }

    set templateId(value)       {
        this._templateId = value
        this._onTemplateChanged()
    }

    get templateId()            {return this._templateId}

    get inheritedFromProject()  {return this._inheritedFromProject}

    // method should be implemented for AutoSave to work
    //onAutoSaveSettings() {/* should be overridden */};

    setInherited() {
        this._mode = AppSettingsMode.INHERITED

        const appSettings = this.getInheritedAppSettings()
        this._inheritedFromProject = gd.session.projects.get(_.get(appSettings, 'inheritedFromProjectId',   null)) || null

        this._initSettings(appSettings)
        this.templateId = undefined
    }

    // method should be implemented for local inherited preset to work

    _onTemplateChanged() {
        if (this._templateId) {
            this._inheritedFromProject = null
        }

        // @ts-ignore
        if (!!this.onAutoSaveSettings && this.autoSave) {
            this.confirmChanges();
            // @ts-ignore
            this.onAutoSaveSettings();

            // clear appSettings in localSettings
            // @ts-ignore
            this.localSettings.appSettings = null;
            this.localSettings.save();

            gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)
        } else {
            // leave only template id for new appSettings
            const newAppSettings = this._templateId ? {templateId: this._templateId} : {templateId: LOCAL_INHERITED_TEMPLATE_ID}
            // get app settings that are not stored in template
            const appSettingsNotInTemplate = _.pick(this, this.templateIgnoredParams)
            // store template id and all other setting that are not in template
            // @ts-ignore
            this.localSettings.appSettings = _.assign({}, newAppSettings, appSettingsNotInTemplate)
            this.localSettings.save()
        }

        // if changed then set all parameters from template
        this._initFromTemplate();

        this.updateMode();
    }

    _onConfigChanged() {

        debug && console.log(debug, "_onConfigChanged()")

        this._templateId = undefined; // it is not apply of template(preset) so templateId should be removed

        // super._onConfigChanged();
        // @ts-ignore
        this.localSettings.appSettings = this.configToJSON();
        this.localSettings.save();
        gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)

        // @ts-ignore
        if (!!this.onAutoSaveSettings && this.autoSave && this.isConfigChanged()) {
            this.confirmChanges();
            // @ts-ignore
            this.onAutoSaveSettings();  // save current view settings to project settings

            // because we save settings to project && this is default settings preset for this project
            // we should clean local settings (!)
            // we assume that save project settings always works (don't wait for success callback of the request)
            this.reset()

            gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)
        }

        this.updateMode();
    }

    // state check
    isConfigChanged(omittedParams: any[] = []) {

        debug && console.log(debug, "isConfigChanged() omitParams=", omittedParams)

        let res : boolean = false;

        const configJSON : any = _.omit(this.configToJSON(), omittedParams);
        if (configJSON && configJSON.templateId) {
            debug && console.log("    this is template case")
            res = configJSON.templateId !== _.get(this._initialConfig, 'templateId', null);
            return res
        }

        const omitted = ['templateId'].concat(omittedParams)
        const currentConfigJSON = _.omit(this.configToJSON(), omitted);
        const initialConfigJSON = _.omit(this.normalizeConfig(this._initialConfig ? this._initialConfig : {}), omitted);

        // console.log("    initialConfig before normalization = ", this._initialConfig)
        // console.log("    initial=", initialConfigJSON)
        // console.log("    current=", currentConfigJSON)

        res = !_.isEqual(currentConfigJSON, initialConfigJSON);

        // console.log("    diff=", getObjectsDifference(currentConfigJSON, initialConfigJSON))
        debug && console.log("    hasChanged=", res)

        return res;
    }

    //conversion methods
    normalizeConfig(obj:any) {

        // debug && console.log(debug, "normalizeConfig()")

        const config : any = {};

        if (_.isEmpty(obj)) {
            config.templateId = DEFAULT_TEMPLATE_ID;
        } else if (obj.templateId) {
            config.templateId = obj.templateId;
        } else {
            // example
            // if (obj.columns && !_.isEqual(obj.columns,this.defaultAppSettings.columns))                         config.columns = obj.columns;
        }

        return config;
    }
}
